export const FooterItems = [
  {
    label: 'Home',
    to: '/home'
  },
  {
    label: 'Company',
    to: '/home',
  },
  {
    label: 'Support',
    to: '/home',
  },
  {
    label: 'Pricing',
    to: '/home'
  }
]